import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Deduction
export const createDeduction = createAsyncThunk(
    'deduction/create',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.post('/deduction', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create deduction');
        }
    }
);

// Fetch All Deductions
export const fetchDeductions = createAsyncThunk(
    'deduction/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get('/deduction');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch deductions');
        }
    }
);

// Fetch Deduction by ID
export const fetchDeductionById = createAsyncThunk(
    'deduction/fetchById',
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get(`/deduction/${id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch deduction');
        }
    }
);

// Update Deduction
export const updateDeduction = createAsyncThunk(
    'deduction/update',
    async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.put(`/deduction/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update deduction');
        }
    }
);

// Delete Deduction
export const deleteDeduction = createAsyncThunk(
    'deduction/delete',
    async (deductionId: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.delete(`/deduction/${deductionId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete deduction');
        }
    }
);
